import { createContext } from 'react';

interface IUserContext {
  user: any;
  isAdmin: boolean;
  setUser: () => Promise<void>;
}

const UserContext = createContext<IUserContext>({} as IUserContext);

export default UserContext;
